import { render, staticRenderFns } from "./PriceRLSPlus.vue?vue&type=template&id=7504e229&scoped=true&"
import script from "./PriceRLSPlus.vue?vue&type=script&lang=js&"
export * from "./PriceRLSPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7504e229",
  null
  
)

export default component.exports